export { default } from './Tooltip'
import { Modifier, Placement, PositioningStrategy } from '@popperjs/core'
import { Options } from '@popperjs/core/lib/modifiers/offset'

export type {
  Modifier,
  Options as OffsetOptions,
  Placement,
  PositioningStrategy,
}
